import React, { useState, useEffect } from 'react';
import { notification, Input, Space } from 'antd';
import service from '../../services/isnaportalsync';
import Button from 'mixins/ui/button/button';
import { localize } from 'mixins/helpers';

const Cell = ({ ...props }) => {
    const [price, setPrice] = useState<number>();

    useEffect(() => {
        setPrice(price);
    }, [price]);

    const payOnClick = () => {
        let values = {};
        Object.assign(values, {
            price: price,
            kbk: props.bcc,
            knp: props.knp,
            taxpayerCode: props.iinBin,
            msuCode: props.msuCode,
        });

        service.initPayment(values).then((data: any) => {
            if (data.data.paymentUrl) {
                const openLink = window.open('', '_blank');
                if (props.language === 'ru')
                    openLink.location.href =
                        data.data.paymentUrl.slice(0, -5) + props.language + '-RU';
                else if (props.language === 'kk_KZ')
                    openLink.location.href = data.data.paymentUrl.slice(0, -5) + 'kk-KZ';
            } else if (data.data.responseInfo.message) {
                notification['error']({
                    message: data.data.responseInfo.code + ' - ' + data.data.responseInfo.status,
                    description:
                        props.language === 'ru'
                            ? data.data.responseInfo.message.split('|')[0]
                            : data.data.responseInfo.message.split('|')[1],
                });
            }
        });
    };

    return (
        <Space
            direction='horizontal'
            align="center"
            size="middle"
        >
            {props.cellValue && (
                <>
                    <div className='cellBlock'>
                        <span
                        className='cellBlock__span'
                        >
                            {props.cellValue}
                        </span>
                        <Input
                            onChange={(e) => setPrice(Number(e.target.value))}
                            className='cellBlock__input'
                        />
                    </div>
                    <Button
                        onClick={payOnClick}
                    >
                        {localize('button.pay', props.translations)}
                    </Button>
                </>
            )}
        </Space>
    );
};

export default Cell;
